import React from "react"
import { T } from "../traks"
import { InfoTip } from "./InfoTip"
import { SibilusCheckbox } from "./Checkbox"

const FormattedRoleName = (role) => {
	switch (role) {
		case "company_administrator":
			return <T>Admin</T>
		case "internal_case_worker":
			return <T>Internal case worker</T>
		case "external_case_worker":
			return <T>External case worker</T>
		default:
			return role
	}
}
const Role = ({ role, handleRoleChange, checked }) => {
	const RoleText = ({ role }) => {
		switch (role) {
			case "company_administrator":
				return (
					<T>Access to: full user administration, generate links, see entries (open and closed), payment options,
						whistleblowerpolicies.
						Administrator cannot access the individual entries unless assigned as caseworker.</T>
				)
			case "internal_case_worker":
				return (
					<T>This is the organizations internal caseworkers (e.g. Managing director, HR, legal counsel, CFO a.o.) - the
						internal caseworker has access to all entries assigned to them. The internal caseworker can comment and
						upload material on entries and forward entries to other caseworkers (external/internal).</T>
				)
			case "external_case_worker":
				return <T>This is the organizations external caseworkers (e.g. Legal counsel or consultants). the external caseworker
					has access to all entries assigned to them. The internal caseworker can comment and upload material on
					entries and forward entries to other caseworkers (external/internal). Please advise that Pentus is not liable
					for any legal fees this option may incur.</T>
			default:
				return <></>
		}

	}

	return (
		<>
			<div className="pt-4 d-flex flex-row w-100">
				<SibilusCheckbox
					id={role +"-check"}
					checked={checked}
					onChange={handleRoleChange}
					name={role}

				>
					<div className="d-flex">
						<div className="b">{FormattedRoleName(role)}</div>
						<InfoTip roleId={role}>
							<RoleText role={role} />
						</InfoTip>
					</div>

				</SibilusCheckbox>
			</div>
		</>
	)
}

export { Role, FormattedRoleName }
